import React from 'react';
const CrossIcon = () => {
    return (React.createElement("svg", { className: "th-c-icon th-c-icon--cross", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M17.6582 6.34299L6.34424 17.657L17.6582 6.34299ZM17.6582 17.657L6.34424 6.34299L17.6582 17.657Z", fill: "black" }),
        React.createElement("path", { d: "M17.6582 6.34299L6.34424 17.657M17.6582 17.657L6.34424 6.34299", stroke: "black", strokeWidth: "2" })));
};
export default CrossIcon;
